const phonePrefix = '+324';

export const getPhoneValue = (value: string) => value.replace(phonePrefix, '');
export const getFullPhone = (value: string) => phonePrefix + value;
